module.exports = __webpack_public_path__ + "static/translation-mobile-app-plp-beb488bcaed7d24d92183f15886e5735.png";